export default __webpack_public_path__ + "static/media/vinos-america-logo.658d1c1d.png";